<template>
  <div class="col-md-6 offset-md-3">
    <div class="login-form mt-4 p-4">
      <div class="row g-3">
        <h4>Регистрация успешно завершена</h4>
        <div class="col-12">
          <button type="submit" class="btn btn-dark float-end ms-3" @click="handleClickActionRegisterFinish">Продолжить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';

import {RootState} from "@/store";

defineOptions({
  name: 'ComponentsAuthRegisterSuccess',
});

const emit = defineEmits<{
  resubscribePage: [];
  switchMode: [mode: string];
}>();

const store = useStore<RootState>();

const handleClickActionRegisterFinish = () => {
  store.dispatch('auth/setWelcomeScreen', false); // TODO: Store it in the localStorage
  emit('switchMode', 'login');
  emit('resubscribePage');
};
</script>

<style scoped>

</style>